import DialogContent from "@material-ui/core/DialogContent";
import { MapperTypeCompanyLevel } from "entities/MapperType";
import { SplitOrdersType } from "entities/SplitOrdersType";
import React, { useEffect } from "react";
import { TextInput, required } from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { PassProps } from "../../../components/_helpers/PassProps";
import { GridForm, GridInput } from "../../../components/GridForm";
import { MapperTypeSelect } from "../../../components/inputs/MapperTypeSelect";
import { getOptionalKeysByType, predefinedByType } from "../../../utils/mapper";
import {
	MapperDataInput,
	MapperDataInputPredefined,
	MapperSettingsInputPredefined,
} from "../../mappers/components/MapperDataInput";

export const AddEditMapperBody = ({ form, ...rest }) => {
	const [isPredefined, setIsPredefined] = React.useState(false);
	const [optionalKeys, setOptionalKeys] = React.useState();
	const { values } = useFormState();

	useEffect(() => {
		const predefinedData = predefinedByType[values["type"]];
		const predefinedSettings = [
			{ key: "order_import_split_orders_type", value: SplitOrdersType.not_split },
			{ key: "is_order_import_add_loading_order_to_ref", value: false },
			{ key: "is_order_import_attach_source_doc", value: true },
			{ key: "is_order_import_split_document_content", value: true },
		];
		if (predefinedData) {
			if (!rest?.record?.data) {
				form.change("data", predefinedData);
				// console.log(rest);
				if (values["type"] === MapperTypeCompanyLevel.order_import) {
					form.change("settings", predefinedSettings);
				}
			}
			setIsPredefined(true);
		} else {
			form.change("data", []);
			form.change("settings", []);
			setIsPredefined(false);
		}
		const optKeys = getOptionalKeysByType(values["type"]);
		setOptionalKeys(optKeys);
	}, [values["type"]]);

	return (
		<PassProps
			component={DialogContent}
			childPropKeys={["resource", "record"]}
			resource="customer-companies-mappers"
			{...rest}
		>
			<GridForm>
				<GridInput
					xs={6}
					component={TextInput}
					source="name"
					label="resources.mappers.fields.name"
					validate={required()}
				/>
				<GridInput
					xs={6}
					component={MapperTypeSelect}
					source="type"
					label="resources.mappers.fields.type"
					enumObj={MapperTypeCompanyLevel}
					disabled={rest?.record || rest.defaultValue}
					defaultValue={rest.defaultValue}
					validate={required()}
				/>
				<GridInput xs={12} source="data" label="resources.mappers.fields.data">
					{isPredefined ? (
						<MapperDataInputPredefined optionalKeys={optionalKeys} formData={values} />
					) : (
						<MapperDataInput />
					)}
				</GridInput>
				{values.type === MapperTypeCompanyLevel.order_import && (
					<GridInput xs={12} source="settings" label="resources.mappers.fields.settings">
						<MapperSettingsInputPredefined formData={values} form={form} />
					</GridInput>
				)}
			</GridForm>
		</PassProps>
	);
};
